import Vue from 'vue'
import App from './App.vue'
import VueI18n from 'vue-i18n'
import messages from '@/lang/en.js'
import router from '@/router'
import axios from 'axios'
import store from './store'

// import VueAwesomeSwiper from 'vue-awesome-swiper'




// import { BootstrapVue } from 'bootstrap-vue'
import { 
  LayoutPlugin,
  CardPlugin,
  BForm,
  ButtonPlugin,
  ImagePlugin,
  SidebarPlugin,
  FormGroupPlugin,
  FormInputPlugin,
  FormTextareaPlugin,
  BBreadcrumb
} from 'bootstrap-vue'
// import { ButtonPlugin } from 'bootstrap-vue'
Vue.use(ButtonPlugin)
Vue.use(LayoutPlugin)
Vue.use(CardPlugin)
Vue.use(ImagePlugin)
Vue.use(SidebarPlugin)
Vue.use(FormGroupPlugin)
Vue.use(FormInputPlugin)
Vue.use(FormTextareaPlugin)
Vue.component('b-form', BForm)
Vue.component('b-breadcrumb', BBreadcrumb)

import '@/style/index.scss'
import 'font-awesome/css/font-awesome.min.css'
// import style
// import 'swiper/css/swiper.css'

// Make BootstrapVue available throughout your project
// Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
// Vue.use(IconsPlugin)


Vue.use(VueI18n)
export const i18n = new VueI18n({
  locale: 'en', // 设置语言环境
  messages
})

Vue.config.productionTip = false

new Vue({
  i18n,
  router,
  store,
  render: h => h(App),
}).$mount('#app')

axios.get('/lang.json')
  .then(Response => {
    let data = Response.data
    console.log(data)
    Object.keys(data).map(item =>{
      i18n.setLocaleMessage(item, Object.assign(data[item]))
    })
  })